module.exports = __webpack_public_path__ + "img/Background3.2259f70f.png";